import { compose, get } from 'lodash/fp';
import { FontSize, FontWeight, LineHeight } from '../theme';

export const getTypography = get('theme.typography');

export const getFontFamily = compose(get('fontFamily'), getTypography);

export const getFontSizes = compose(get('fontSize'), getTypography);

const createFontSizeGetter = (size: FontSize, units = 'px') =>
    compose((fontSize: string) => `${fontSize}${units}`, get(size), getFontSizes);

export const getMicroFontSize = createFontSizeGetter(FontSize.Micro);
export const getSmallFontSize = createFontSizeGetter(FontSize.Small);
export const getNormalFontSize = createFontSizeGetter(FontSize.Normal);
export const getSemiMediumFontSize = createFontSizeGetter(FontSize.SemiMedium);
export const getMediumFontSize = createFontSizeGetter(FontSize.Medium);
export const getLargeFontSize = createFontSizeGetter(FontSize.Large);
export const getExtraLargeFontSize = createFontSizeGetter(FontSize.ExtraLarge);

export const getFontWeights = compose(get('fontWeight'), getTypography);

export const getFontWeight = (weight: FontWeight) => compose(get(weight), getFontWeights);

const createFontWeightGetter = (weight: FontWeight) => compose(get(weight), getFontWeights);

export const getRegularFontWeight = createFontWeightGetter(FontWeight.Regular);
export const getMediumFontWeight = createFontWeightGetter(FontWeight.Medium);
export const getSemiBoldFontWeight = createFontWeightGetter(FontWeight.SemiBold);
export const getBoldFontWeight = createFontWeightGetter(FontWeight.Bold);

export const getLineHeights = compose(get('lineHeight'), getTypography);

export const getLineHeight = (size: LineHeight) => compose(get(size), getLineHeights);

const createLineHeightGetter = (height: LineHeight, units = 'px') =>
    compose((lineHeight: string) => `${lineHeight}${units}`, get(height), getLineHeights);

export const getMicroLineHeight = createLineHeightGetter(LineHeight.Micro);
export const getSmallLineHeight = createLineHeightGetter(LineHeight.Small);
export const getNormalLineHeight = createLineHeightGetter(LineHeight.Normal);
export const getSemiMediumLineHeight = createLineHeightGetter(LineHeight.SemiMedium);
export const getMediumLineHeight = createLineHeightGetter(LineHeight.Medium);
export const getLargeLineHeight = createLineHeightGetter(LineHeight.Large);
export const getExtraLargeLineHeight = createLineHeightGetter(LineHeight.ExtraLarge);
